var React = require('react');

function DownloadNew (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"fill":"currentColor","d":"M13.5 12.464v6.576a1 1 0 0 1-2 0v-6.59l-1.843 1.843a1 1 0 0 1-1.414-1.414l3.536-3.536c.042-.042.086-.08.133-.112a.998.998 0 0 1 1.374.191l3.457 3.457a1 1 0 1 1-1.414 1.414L13.5 12.464zM8 4.45h9a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2z","id":"download-new-a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"download-new-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#download-new-a"})),React.createElement("g",{"mask":"url(#download-new-b)","key":1},[React.createElement("path",{"fill":"#FFF","d":"M0 0h25v25H0z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M0 0h25v25H0z","key":1})])])]);
}

DownloadNew.defaultProps = {"width":"25","height":"25"};

module.exports = DownloadNew;

DownloadNew.default = DownloadNew;
